/**
 * Renders non-reversal line items that are not listed in the
 * `LINE_ITEMS` array in util/types.js
 *
 * The line items are rendered so that the line item code is formatted to human
 * readable form and the line total is printed as price.
 *
 * If you require another kind of presentation for your line items, add them to
 * the `LINE_ITEMS` array in util/types.js and create a specific line item
 * component for them that can be used in the `BookingBreakdown` component.
 */
import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_CUSTOMER_BOLDLY_FEE, propTypes } from '../../util/types';
import { bool } from 'prop-types';

import css from './BookingBreakdown.module.css';

const LineItemCustomerBoldlyFee = props => {
  const { transaction, intl, isCustomer } = props;

  const customerBoldlyFee = transaction.attributes.lineItems.find(
    item => item.code === LINE_ITEM_CUSTOMER_BOLDLY_FEE && !item.reversal
  );

  const formattedFee = customerBoldlyFee?.lineTotal ? formatMoney(intl, customerBoldlyFee.lineTotal) : null;

  return isCustomer && customerBoldlyFee ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="BookingBreakdown.boldlyFee" />
      </span>
      <span className={css.itemValue}>{formattedFee}</span>
    </div>
  ) : null;
};

LineItemCustomerBoldlyFee.propTypes = {
  transaction: propTypes.transaction.isRequired,
  intl: intlShape.isRequired,
  isCustomer: bool,
};

export default LineItemCustomerBoldlyFee;
